import {Sidenav} from "../typescript/widgets/sidenav";
import {ArticleContent} from "../typescript/widgets/articleContent";
import { Menu } from "../typescript/menu";
import { Accessibility } from "./accessibility/accessibility";

global.M = require("@materializecss/materialize");

class Main{

    static init() {
      document.addEventListener('DOMContentLoaded', Main.onDocumentLoaded, false);
    }

    private static onDocumentLoaded() {
        Sidenav.init();
        ArticleContent.init()
	  }
}
Main.init()
Menu.init()
Accessibility.init()
